export default __webpack_public_path__ + "static/media/css-512.187e9bdb.png";